/**
 * Shared agent UI primitives (brand face, empty / loading).
 * CHARACTER.md: product surfaces use character poses, not Agent M logo.
 */

export {
  AgentEmptyState,
  type AgentEmptyStateProps,
  type AgentEmptyStateAction,
  type AgentEmptyStateVariant,
  type AgentEmptyPose,
} from './AgentEmptyState'
